import React, { useEffect, useRef, useContext, useState } from "react";
import { ZoomMtg } from "@zoom/meetingsdk";
import { createRoot } from "react-dom/client";
import AlertContext from "../../context/AlertContext";
import ZoomPopup from "./ZoomPopup";
import Zoomact from "./ZoomAct";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import { getDataFromStorage } from "../../util";
import constants from "../../constants";
import ModuleHooks from "../../Hooks/ModuleHooks";
import Popup from "../CommonComponents/Popup";

export default function ZoomAdminView(Props) {
  const {
    participants,
    setparticipants,
    setshowzoommodal,
    setZoomBatchStudents,
    batchNames,
    handleUnAuthAlert,
    setShowNotify,
    navigate,
    isCommonPopup,
  } = useContext(AlertContext);
  const { handlePopupStates, clearPopupStates } = ModuleHooks();
  const axios = useAxiosPrivate();

  const handleNavFun = () => {
    clearPopupStates();
    navigate("/batches");
  };
  const handlePopupOkFunc = () => {
    handleUnAuthAlert();
    clearPopupStates();
  };

  const handleResponse = (title, msg, isUnAuth) => {
    setShowNotify({
      show: true,
      title: title,
      msg: msg,
    });
  };

  let authEndpoint = "node/zoom/auth",
    sdkKey = process.env.REACT_APP_ZOOM_MEETING_SDKKEY,
    meetingNumber = process.env.REACT_APP_ZOOM_MEETING_NUMBER,
    passWord = process.env.REACT_APP_ZOOM_MEETING_PASSWORD,
    userName = getDataFromStorage("name"),
    userEmail = getDataFromStorage("email"),
    registrantToken = "",
    zakToken = "",
    leaveUrl = `${process.env.REACT_APP + getDataFromStorage("role") ===
      constants.Roles.learner
      ? "/home"
      : "/batches"
      }`;
  const hasjoined = useRef(false);
  const batchStudentsData = useRef({});
  const [BatchStudents, setBatchStudents] = useState({});
  const [filteredBatchStudents, setFilteredBatchStudents] = useState({});

  useEffect(() => {
    if (Props.showlive) {
      setTimeout(() => {
        getSignature();
      }, 2000);
    }
  }, [Props.showlive]);

  function getSignature() {
    axios
      .post(
        authEndpoint,
        {
          meetingNumber: meetingNumber,
          role: 1,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((response) => {
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          ZoomMtg.i18n.load("en-US");
          ZoomMtg.preLoadWasm();
          ZoomMtg.prepareWebSDK();
          startMeeting(response.data.data.signature);
        } else {
          handleResponse(
            "Warning !",
            "Encountered an error while get signature for join zoom meeting.",
            false
          );
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.message.includes("403")) {
          handleResponse("Error !", "The session token is invalid", true);
        } else {
          handleResponse(
            "Error !",
            "Something went wrong… Please, try again",
            false
          );
        }
      });
  }

  function startMeeting(signature = null) {
    document.getElementById("zmmtg-root").style.display = "block";
    ZoomMtg.init({
      leaveUrl: leaveUrl,
      patchJsMedia: true,
      disablePreview: true,
      isSupportAV: true,
      defaultView: "gallery",
      success: (success) => {
        autojoin();
        ZoomMtg.join({
          signature: signature,
          sdkKey: sdkKey,
          meetingNumber: meetingNumber,
          passWord: passWord,
          userName: userName,
          userEmail: userEmail,
          tk: registrantToken,
          zak: zakToken,
          success: (success) => {
            autojoin();
            HideJoinAudio();
            getAttendeesList();
            axios
              .post(
                "node/learner/eventlog",
                {
                  eventtext: "Joined Zoom",
                  userid: parseInt(getDataFromStorage("learnerid")) ?? null,
                  qnid: null,
                  testid: null,
                  tag: "ZOOM_JOIN",
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              )
              .then((res) => {
                console.log("res", res);
              })
              .catch((err) => {
                console.error("error", err);
              });
          },

          error: (error) => {
            console.log(error);
            handleResponse(
              "Error !",
              "Encountered an error while join to zoom meeting",
              false
            );
          },
        });
      },
      error: (error) => {
        console.log(error);
        handleResponse(
          "Error !",
          "Encountered an error while initiate zoom",
          false
        );
      },
    });
    ZoomMtg.inMeetingServiceListener("onUserJoin", function (data) {
      addParticipant(data);
      wait(autoVideo, 5);
    });
    ZoomMtg.inMeetingServiceListener("onUserLeave", function (data) {
      if (document.getElementById(data.userId) != null) {
        document.getElementById(data.userId).remove();
      }
      removeParticipant(data);
    });
  }

  function getAttendeesList() {
    ZoomMtg.getAttendeeslist({
      meetingNumber: meetingNumber,
      success: function (res) {
        console.log("res of getAttendeeslist", res);
        for (var i = 0; i < res.result.attendeesList.length; i++) {
          addParticipant(res.result.attendeesList[i]);
        }
        addfooter(BatchStudents);
      },
      error: function (res) {
        console.log(res);
        handleResponse(
          "Error !",
          "Encountered an error while get attendees list",
          false
        );
      },
    });
  }

  function addParticipant(data) {
    if (data.userName?.includes("$")) {
      let batchname = data.userName.split("$$")[0],
        UserName = data.userName.split("$$")[1],
        testdata = data.userName.split("$$")[2]?.split(",");
      let nameElement = document.getElementsByClassName(
        "video-avatar__avatar-name"
      )[0];
      if (nameElement)
        nameElement.innerHTML = UserName.substring(0, UserName.indexOf("("));
      let lpid = parseInt(testdata[0]),
        lpconfigid = parseInt(testdata[2]), /* TODO: Zoom Integration */
        testid = parseInt(testdata[1]), /* TODO: Zoom Integration */
        learnerid = parseInt(testdata[3]),
        libtype = parseInt(testdata[4]),
        qnid = parseInt(testdata[5]),
        qnno = parseInt(testdata[6]),
        tempbatch = JSON.parse(JSON.stringify(batchStudentsData.current));
      console.log(tempbatch);

      if ((!data.isHost || !data.isCoHost) && batchNames.includes(batchname)) {
        data.status = "zoomstudentadded";
        data.action = "";
        let temp = [...participants, data];
        setparticipants(temp);

        if (!tempbatch.hasOwnProperty(batchname)) {
          // If batchname does not exist, create a new batch object
          tempbatch[batchname] = {};
        }

        tempbatch[batchname][learnerid] = {
          name: UserName,
          lpid: lpid,
          lpconfigid: lpconfigid,
          testid: testid,
          learnerid: learnerid,
          libtype,
          qnid,
          qnno,
          checked: false,
        };
        setBatchStudents(tempbatch);
        batchStudentsData.current = tempbatch;
        setFilteredBatchStudents(tempbatch);
        setZoomBatchStudents(tempbatch);
        addfooter(tempbatch);
      }
    }
  }

  function removeParticipant(data) {
    if (data.userName?.includes("$")) {
      let batchname = data.userName.split("$$")[0],
        testdata = data.userName.split("$$")[2].split(","),
        learnerid = parseInt(testdata[3]),
        tempbatch = JSON.parse(JSON.stringify(batchStudentsData.current)),
        temp = participants;
      for (let i = 0; i < temp.length; i++) {
        if (temp[i].userId === data.userId) {
          temp[i].status = "zoomstudentremoved";
        }
      }
      setparticipants(temp);

      let tempbatchobj = tempbatch[batchname];
      axios
        .post(
          "node/learner/eventlog",
          {
            eventtext: "Left Zoom",
            userid: learnerid ?? null,
            qnid: tempbatch[batchname][learnerid].qnid ?? null,
            testid: tempbatch[batchname][learnerid].testid ?? null,
            tag: "ZOOM_LEAVE",
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("res", res);
        })
        .catch((err) => {
          console.error("error", err);
        })
        .finally(() => {
          delete tempbatchobj[learnerid];
          tempbatch[batchname] = tempbatchobj;
          setBatchStudents(tempbatch);
          batchStudentsData.current = tempbatch;
          setFilteredBatchStudents(tempbatch);
          setZoomBatchStudents(tempbatch);
          addfooter(tempbatch);
        });
    } else {
      axios
        .post(
          "node/learner/eventlog",
          {
            eventtext: "Left Zoom",
            userid: getDataFromStorage("learnerid"),
            qnid: null,
            testid: null,
            tag: "ZOOM_LEAVE",
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("res", res);
        })
        .catch((err) => {
          console.error("error", err);
        });
    }
  }

  function addfooter(updatedbatch) {
    const zoominter = setInterval(() => {
      let div = document.getElementsByClassName("footer__btns-container")[0];

      if (document.getElementById("zoom_student_options_id") !== null) {
        document.getElementById("zoom_student_options_id").remove();
      }

      if (typeof div !== "undefined") {
        let muitem = document.createElement("div");
        muitem.setAttribute("id", "zoom_student_options_id");
        muitem.setAttribute("class", "footer__button-wrap");
        muitem.setAttribute("feature-type", "zoomactions");
        document
          .getElementsByClassName("footer__btns-container")[0]
          .appendChild(muitem);
        createRoot(document.getElementById("zoom_student_options_id")).render(
          <Zoomact setshowzoommodal={setshowzoommodal} />
        );

        clearInterval(zoominter);
      }
    }, 1000);
  }

  function HideJoinAudio() {
    let joinBtn = document.getElementsByClassName(
      "join-audio-by-voip__join-btn"
    )[0];
    if (joinBtn) {
      wait(JoinAudioAuto, 5);
      wait(OpenJoinAudio, 5);
    } else {
      wait(OpenJoinAudio, 5);
      wait(JoinAudioAuto, 5);
    }
    return;
  }

  function OpenJoinAudio() {
    let btn = document.getElementsByClassName("join-audio-container__btn")[0];

    let joinDialog = document.getElementsByClassName("join-dialog")[0];
    if (btn && !joinDialog) {
      btn.click();
    }
    return;
  }

  function JoinAudioAuto() {
    let btn = document.getElementsByClassName(
      "join-audio-by-voip__join-btn"
    )[0];
    if (btn) {
      btn.click();
    }
    return;
  }

  let wait = function (callback, seconds) {
    return window.setTimeout(callback, seconds * 1000);
  };

  function autojoin() {
    let joinBtn = document.getElementsByClassName("preview-join-button")[0];
    if (!hasjoined.current) {
      if (joinBtn) {
        joinBtn.click();
        hasjoined.current = true;
      } else {
        wait(autojoin, 5);
      }
      return;
    }
  }

  const autoVideo = () => {
    let videoBtn = document.getElementsByClassName(
      "send-video-container__btn"
    )[0];
    videoBtn && videoBtn.click();
  };
  // console.log("BatchStudents", BatchStudents);

  return (
    <div className="ZoomApp">
      <div className="zoomactions"></div>
      {isCommonPopup && (
        <div className="popup-overlay">
          <Popup />
        </div>
      )}
      <ZoomPopup
        batchdata={BatchStudents}
        setBatchData={setBatchStudents}
        batchStudentsData={batchStudentsData}
        filteredBatchStudents={filteredBatchStudents}
        setFilteredBatchStudents={setFilteredBatchStudents}
      />
    </div>
  );
}
